import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class Table extends Vue {
  // Table
  data = []
  checkedRows: [] = []
  tableLoading: boolean = false
  selectedAll = false
  selectedCount = 0
  selectedRow = null

  // has Datas initially ?
  firstLoad: boolean = true
  hasData = false

  @Watch('data')
  updateSelectedAll(data) {
    if (this.selectedAll) {
      this.checkedRows = data
    }
  }

  get hasRowChecked(): boolean {
    return this.checkedRows.length > 0
  }

  updateSelected(array) {
    this.selectedCount = array.length
    this.selectedAll = array.length > 0 && array.length === this.data.length
  }
}

